import { observer } from 'mobx-react';
import { useMapStore } from 'contexts/RootStore.context';

// component to show floor count of assets or users depending on permissions enabled.
// assetfloorcount should be the default unless this is not enabled and user_tracking is.
export const FloorCountBadge = observer(({ ordinal }: { ordinal: number }) => {
  const {
    getBuildingAssets,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    users, // this should be here to force re-render on changes of users
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    assets, // this should be here to force re-render on changes of assets
    selectedBuildingId,
    getBuildingUsers,
    showAssetMarkers,
    showUserMarkers } = useMapStore()

  const floorAssetCount = getBuildingAssets(selectedBuildingId)[ordinal].length
  const floorUserCount = getBuildingUsers(selectedBuildingId)[ordinal].length

  const shouldShowFloorAssetCount = floorAssetCount > 0 && showAssetMarkers;
  const shouldShowFloorUserCount = floorUserCount > 0 && showUserMarkers;

  return (
    <>
      {shouldShowFloorAssetCount && <span className="count-readout">{floorAssetCount}</span>}
      {!shouldShowFloorAssetCount && shouldShowFloorUserCount && <span className="count-readout">{floorUserCount}</span>}
    </>
  );
})